import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/home/Hero";
import QuickAccess from "@/components/home/QuickAccess";
import Services from "@/components/home/Services";
import Manifesto, { Marquee } from "@/components/home/Manifesto";
import Testimonials from "@/components/home/Testimonials";
import Insights from "@/components/home/Insights";
import Contact from "@/components/home/Contact";
import { scrollToSection } from "@/components/SmoothScroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.anchor) {
      const t = setTimeout(() => scrollToSection(`#${location.state.anchor}`, -60), 500);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div data-testid="home-page">
      <Hero />
      <QuickAccess />
      <Services />
      <Marquee />
      <Manifesto />
      <Testimonials />
      <Insights />
      <Contact />
    </div>
  );
}
